// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import {Svg_img} from '../ui/svg_img';
import styles from './free_vs_premium.module.less';
import {Button} from '../../../shared/button';
import {open_store} from '../ui/install_btn';
import {use_download} from '../shared/use_download';
import {guess_os_and_version} from '../client_hints_global';
import {use_screen} from '../lib/screen_util';
import {guess_browser} from 'zuser_agent';
import {mobile_links} from '../ui/use_install_info';
import {Editor} from '../../../shared/editor/editor';

const use_free_vpn_button = ()=>{
    const {screen} = use_screen();
    const is_mobile = screen=='xs' || screen=='sm';
    const sys = guess_os_and_version();
    const browser = guess_browser();
    const {download} = use_download({});

    const is_extension_installed = ()=>{
        return !!(window as any).hola_ext ||
            !!(window as any).hola_extension;
    };

    const handle_get_free_vpn = ()=>{
        if (is_mobile)
        {
            if (sys.os=='android')
            {
                if (browser.huawei)
                    return window.location.href = mobile_links.huawei;
                // XXX dmitriikup: URG request from noav to remove all Samsung
                // mentions from www
                // if (browser.samsung)
                //     return window.location.href = mobile_links.samsung;
                return window.location.href =
                    'https://play.google.com/store/apps/details'
                    + '?id=org.hola';
            }
            if (sys.os=='ios')
                return window.location.href = mobile_links.ios;
            return window.location.href = mobile_links.mobile;
        }
        if (!is_extension_installed())
            return open_store();
        return download({});
    };

    const handle_compare_plans = ()=>{
        window.location.href = 'https://hola.org/premium';
    };

    return {handle_get_free_vpn, handle_compare_plans};
};

export const Free_vs_premium = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.container}>
      <div className={styles.header_container}>
        <h3 className={styles.header}>Free vs Premium</h3>
        <h4 className={styles.header}>Free vs Premium</h4>
        <p className={cn([theme.u2, theme.med])}>
          Choose What Fits Your Needs
        </p>
      </div>
      <div className={styles.card_container}>
        <div className={styles.card}>
          <p className={cn([theme.u2, theme.color_n700])}>Free</p>
          <div className={styles.features}>
            {[
              'Access to many global locations',
              'Quick, simple setup',
              '$0/month',
            ].map((item, i)=><div key={i} className={styles.check_item}>
                  <Svg_img id={'hola2023/icons/18/check_gray.svg'}
                    w={18} h={18} cls={styles.check_icon}/>
                  <p className={cn([theme.p3, theme.reg])}>{item}</p>
                </div>)}
          </div>
        </div>
        <div className={cn(styles.card, styles.premium_card)}>
          <p className={cn([theme.u2, theme.color_n700])}>Premium</p>
          <div className={styles.features}>
            {[
              'Dedicated network resources',
              'Higher speeds and more stable performance',
              'More countries and advanced features',
              'Priority support'
            ].map((item, i)=><div key={i} className={styles.check_item}>
                  <Svg_img id={'hola2023/icons/18/check_gray.svg'}
                    w={18} h={18} cls={styles.check_icon}/>
                  <p className={cn([theme.p3, theme.reg])}>{item}</p>
                </div>)}
            <div className={styles.check_item}>
              <Svg_img id={'hola2023/icons/18/check_gray.svg'}
                w={18} h={18} cls={styles.check_icon}/>
              <p className={cn([theme.p3, theme.reg])}>
                Paid plan (<a href="https://hola.org/premium"
                  className={styles.link}>see pricing</a>)
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.button_container}>
        <Buttons />
      </div>
    </div>;
};

const Buttons = ()=>{
    const {handle_get_free_vpn, handle_compare_plans} = use_free_vpn_button();
    return <>
      <Button caption="Get Hola Free VPN" on_click={handle_get_free_vpn}
        size="md"/>
      <Button caption="Compare Plans" on_click={handle_compare_plans}
        color="transparent" size="md"/>
    </>;
};

interface i_free_vs_premium_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Free_vs_premium_editor = (
props: i_free_vs_premium_editor_props)=>{
    return <Editor value={props.value} on_change={props.on_change}
      editors={[]}/>;
};
